import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import '../../shared/styles/style.sass';
import './index.sass';
import App from './app';
import React from 'react';
import loadPolyfills from '../../shared/utils/load-polyffils';

if (document.getElementById('tint-themes')) {
  loadPolyfills();
  const loaderElement = document.getElementById('loading-img');
  loaderElement && loaderElement.remove();

  render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('tint-themes')
  );
}
